import React, { useEffect, useRef, useState } from 'react'
import { Box, Button, Checkbox, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { valuationTableData } from '../../GSConstants'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import EditIcon from '@mui/icons-material/Edit'
import { connect } from 'react-redux'
import { getBranchConfigOrEwbillinfo, updateModal } from '../../../../../store/common/common_action'
import { getBookingConsType, getGSBranchValuationDetailsTableData, getgetGSEditValuationDetails, } from '../../../../../store/generalSetting/GSAction'
import { focusElemnt, isEmpty, navigation3 } from '../../../../common/helper'
import moment from 'moment'
import CreateEditValuationChrge from './CreateEditValuationChrge'
const ValuationChargeTable = (props) => {
  const { data, updateModal, getGSBranchValuationDetailsTableData, getgetGSEditValuationDetails, getBookingConsType, getBranchConfigOrEwbillinfo } = props
  const { common, generalSettingReducer } = data
  const { gsValuationChargeTableData } = generalSettingReducer
  const { showModal, modalType, loginData,companySettings } = { ...common }
  const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
  const DefaultCurrencyID=companySettings[0]?.DefaultCurrencyID
  const [showTableData, setShowTableData] = useState([])
  const [editTableData, setEditTableData] = useState('')
  const [tableData, setTableData] = useState([])
  const openModle = { id: 'VALUATIONCHARGE', lrListLabel: 'Add Valuation Charge', isSaved: false }
  const openValuationChargeModle = { id: 'ADDVALUATIONCHARGE', lrListLabel: 'Add Valuation Charge', isSaved: false }
  const [hasMore, setHasMore] = useState(false);
  const [page, setPage] = useState(0); // Initial page number
  const [pageData, setPageData] = useState([])
  const pageSize = 100;
  const tableRef = useRef(null);
  //UseEffect Start
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const obj = {
        CompanyID: loginData?.intCompanyID,
      }
      getGSBranchValuationDetailsTableData(obj)
      consignmentTypeApiCall()
      // focusElemnt('addValChargeBtn')
      const obj2 = {
        intUserID: 0,
        intCompanyID: loginData?.intCompanyID,
        intBranchID: 0,
        strBranchName: '',
        strBranchCode: '',
        intStateID: 0,
        intCityID: 0,
        intIsActive: 1,
      }
      getBranchConfigOrEwbillinfo(obj2)
    }
  }, [loginData])


  useEffect(() => {
    if (!isEmpty(gsValuationChargeTableData)) {
      const updatedData=gsValuationChargeTableData?.Table.map((val)=>({...val,PaymentType:UseToPayAsCOD===1&&val.PaymentTypeID===2?'COD':val.PaymentTypeID===7?'COD Manual':val.PaymentTypeID===9?'COD DDDV':val.PaymentType}))
      setShowTableData(updatedData)
      setTableData(updatedData)
      setPageData(updatedData.slice(0, pageSize))
      setHasMore(updatedData.length > pageSize)
      setSearchData(
        {
          CompanyName: '',
          BranchName: '',
          CityName: '',
          StateName: '',
          SubType: '',
          PaymentType: '',
          ModifiedUser: '',
        }
      )
      // setTableData(updatedData)
    }
  }, [gsValuationChargeTableData])
  useEffect(() => {
    const fetchData = () => {
      if (hasMore) {
        setPageData(showTableData.slice(page * pageSize, (page + 1) * pageSize))
        setHasMore(page * pageSize < showTableData.length) // Check if there's more data available
      } else {
        setPage(0)
        setPageData(showTableData.slice(0, pageSize))
        setHasMore((page+1) * pageSize < showTableData.length) // Check if there's more data available
      }
    }
    if (page > 0) {
      fetchData()
    }
  }, [page])
  useEffect(() => {
    if (page > 0) {
      setPage(0)
    } else {
      if (hasMore) {
        setPageData(showTableData.slice(page * pageSize, (page + 1) * pageSize))
        setHasMore(page * pageSize < showTableData.length) // Check if there's more data available
      } else {
        setPage(0)
        setPageData(showTableData.slice(0, pageSize))
        setHasMore((page + 1) * pageSize < showTableData.length) // Check if there's more data available
      }
    }
  }, [showTableData])
  const isProgrammaticScroll = useRef(false);
  const handleScroll = (event) => {
    if (isProgrammaticScroll.current) return;
    const { scrollTop, scrollHeight, clientHeight } = event.target
    const isBottom = scrollTop + clientHeight >= scrollHeight-1
    const isTop = scrollTop === 0;
    if (isBottom && hasMore) {
      setPage((prevPage) => prevPage + 1)
      programmaticScroll(130)
    } else if (isTop && page > 0) {
      setPage((prevPage) => prevPage - 1)
      programmaticScroll(scrollHeight - 30)
    }
  }
  const programmaticScroll = (top) => {
    isProgrammaticScroll.current = true
    const handleScrollEnd = () => {
      const { scrollTop } = tableRef.current;
      if (scrollTop - top <= 2) {
        isProgrammaticScroll.current = false; 
        tableRef.current.removeEventListener('scroll', handleScrollEnd);
      }
    };
    tableRef.current.addEventListener('scroll', handleScrollEnd);
    tableRef.current.scrollTo({ top })
  }
  useEffect(() => {
    focusElemnt(`contains-1`)
    // focusElemnt('addValChargeBtn')
  }, [])
  //UseEffect End
  const consignmentTypeApiCall = () => {
    const obj = {
      intConsignmentSubTypeID: 0,
      intCompanyID: loginData?.intCompanyID,
      intConsignmentTypeID: 0,
      strSubType: '',
      intIsActive: 1,
      intIsDeleted: 0,
    }
    getBookingConsType(obj, true, 24 * 60 * 60 * 1000)
  }
  const editClickUpdate = (item) => {
    updateModal(true, 'VALUATIONCHARGE')
    setEditTableData(item)
    focusElemnt('checkValBasedValue')
  }
  const addNewValuationCharge = (item) => {
    focusElemnt('selectBranch')
    updateModal(true, 'ADDVALUATIONCHARGE')
  }
  const editApiCall = (item) => {
    const obj = {
      CompanyID: loginData?.intCompanyID,
      BranchID: item.BranchId,
      UserID: loginData?.intUserID,
      ConsignmentID: item.ConsignmentSubTypeId,
      PaymentType: item?.PaymentTypeID,
    }
    getgetGSEditValuationDetails(obj)
    focusElemnt('checkValBasedValue')
  }
  const EditClick = (isEdit) => {
    return <CreateEditValuationChrge isEdit={isEdit} editTableData={editTableData} DefaultCurrencyID={DefaultCurrencyID}/>
  }
  const [searchData, setSearchData] = useState({
    CompanyName: '',
    BranchName: '',
    CityName: '',
    StateName: '',
    SubType: '',
    PaymentType: '',
    ModifiedUser: '',
  })
  useEffect(() => {
    let fiterData = tableData?.filter((val) =>
      (searchData.CompanyName === '' || val.CompanyName.toLowerCase().includes(searchData.CompanyName.toLowerCase())) &&
      (searchData.BranchName === '' || val.BranchName.toLowerCase().includes(searchData.BranchName.toLowerCase())) &&
      (searchData.CityName === '' || val.CityName.toLowerCase().includes(searchData.CityName.toLowerCase())) &&
      (searchData.StateName === '' || val.StateName.toLowerCase().includes(searchData.StateName.toLowerCase())) &&
      (searchData.SubType === '' || val.SubType.toLowerCase().includes(searchData.SubType.toLowerCase())) &&
      (searchData.PaymentType === '' || val.PaymentType.toLowerCase().includes(searchData.PaymentType.toLowerCase())) &&
      (searchData.ModifiedUser === '' || val.ModifiedUser.toLowerCase().includes(searchData.ModifiedUser.toLowerCase()))
    )
    setShowTableData(fiterData)
  }, [searchData])
  const handleChangeContain = (e, field) => {
    setSearchData({ ...searchData, [field]: e.target.value })
  }
  const InsideRowContent = ({ index, item }) => {
    return (
      <TableRow key={index}>
        <TableCell style={{ minHeight: '36px', textAlign: 'right', fontSize: '13px', color: '#444' }}>{index + 1}</TableCell>
        <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '13px', color: '#444' }}>{item.CompanyName}</TableCell>
        <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '13px', color: '#444' }}>{item.BranchName}</TableCell>
        <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '13px', color: '#444' }}>{item.CityName}</TableCell>
        <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '13px', color: '#444' }}>{item.StateName}</TableCell>
        <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '13px', color: '#444' }}>{item.SubType}</TableCell>
        <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '13px', color: '#444' }}>{item.PaymentType}</TableCell>
        <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '13px', color: '#444' }}>
          <Tooltip
            title={`${item.ModifiedUser} (${item.UserBranch})`}
            PopperProps={{
              sx: { '& .MuiTooltip-tooltip': { backgroundColor: '#DAEDFE', color: '#000', minHeight: '26px', display: 'flex', fontWeight: '400', alignItems: 'center', marginTop: '5px !important', fontSize: '12px', }, },
            }}
            placement="bottom-start"
          >
            <span onMouseOver={(e) => (e.currentTarget.style.color = '#0086FF')} onMouseOut={(e) => (e.currentTarget.style.color = '#444')}
              style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer', textDecoration: 'underline', }}>
              {item.ModifiedUser}
            </span>
          </Tooltip>
        </TableCell>
        <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '13px', color: '#444' }}>{moment(item.ModifiedDateTime).format('HH:mm, DD-MMM-YY')}</TableCell>
        <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666' }}>
          <Checkbox checked={item.IsActive === 1}
            // inputProps={{ 'aria-label': 'controlled' }}
            sx={{ padding: '0', borderRadius: '0' }}
          />
        </TableCell>
        <TableCell>
          <span id={`Edit-${index}`} tabIndex={0} style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold' }}
            onClick={() => { editClickUpdate(item); editApiCall(item) }}
            onKeyDown={(e) => navigation3(e, showTableData.length === index + 1 ? "index-1" : `Edit-${index + 1}`, index === 0 ? `contains-${index + 7}` : `Edit-${index - 1}`, () => { editClickUpdate(item); editApiCall(item); focusElemnt('checkValBasedValue') })}
          >
            <EditIcon sx={{ marginRight: '3px' }} />
            Edit
          </span>
        </TableCell>
      </TableRow>
    )
  }
  const keyboardNavigation = (event, prevId, nextId) => {
    if (event.key === 'Escape') {
      focusElemnt(prevId)
    }
    if (event.key === 'Enter') {
      focusElemnt(nextId)
    }
  }

  return (
    <>
      <Box style={{ display: 'flex', paddingTop: '12px', gap: '16px', width: '60%' }} className='itemButtons'>
        <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, `contains-1`, "addValChargeBtn", () => { })}>
          <Box id='addValChargeBtn' tabIndex={0}>
            <Button variant="outlined" sx={{ width: '100%' }} className="receiveitembtn"
              autoFocus={true}
              // tabIndex={0}
              onClick={(item) => addNewValuationCharge(item)}
            >
              + ADD NEW VALUATION CHARGE
            </Button>
          </Box>
        </Item>
      </Box>
      <Box style={{ paddingTop: '18px' }}>
        <Stack sx={{ height: '62vh', minWidth: "100%" }}>
          <TableContainer ref={tableRef} className="lr-popup-table lrModel cancelTransferTable scrollBlue" component={Paper} onScroll={handleScroll} >
            <Table style={{ width: '100%' }}
            >
              <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '2', }} sx={{
                '& .MuiTableCell-root': {
                  padding: '8px 6px !important'
                }
              }}>
                <TableRow style={{ background: '#d9edff', width: '100%' }}>
                  {valuationTableData.map((val, i) => {
                    return (
                      <TableCell style={{ fontSize: '12px', ...val.headerSx, height: '40px' }} key={i}>
                        {val.headerName}
                      </TableCell>
                    )
                  })}
                </TableRow>
                <TableRow>
                  {valuationTableData.map((item, index) =>
                    item.showfilter ? (
                      <TableCell key={`FTH-${index}`}>
                        <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                          <input
                            id={`contains-${index}`}
                            className="field"
                            autocomplete="off"
                            value={searchData[item.field]}
                            name="cancelSearchInput"
                            style={{ width: '100%', height: '30px' }}
                            placeholder="Contains"
                            onChange={(e) => handleChangeContain(e, item.field)}
                            onKeyDown={(e) => keyboardNavigation(e, index === 1 ? 'addValChargeBtn' : `contains-${index - 1}`, index === 7 ? `Edit-0` : `contains-${index + 1}`)}
                          />
                          <FilterAltIcon style={{ color: '#AAA' }} />
                        </div>
                      </TableCell>
                    ) : (
                      <TableCell></TableCell>
                    )
                  )}
                </TableRow>
              </TableHead>
              {showTableData?.length <= 0 ? (
                <>
                  <TableBody sx={{
                    '& .MuiTableCell-root': {
                      padding: '6px !important'
                    }
                  }}>
                    <TableRow>
                      <TableCell colSpan={11}>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '20px',
                            marginBottom: '20px',
                            color: 'red',
                            fontSize: '14px',
                          }}
                        >
                          <span>No results found. Please refine your search parameters and search again.</span>
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </>
              ) : showTableData.length > 0 ? (
                <TableBody className="filter-data-row" style={{ border: 'none' }} sx={{
                  '& .MuiTableCell-root': {
                    padding: '6px !important'
                  }

                }}
                >
                  {pageData?.map((item, index) => (
                    <InsideRowContent item={item} index={page * pageSize + index} key={index} />
                  ))}
                </TableBody>
              ) : (
                ''
              )}
            </Table>
          </TableContainer>
        </Stack>
      </Box>
      {showModal && [openModle.id].includes(modalType) && EditClick(true)}
      {showModal && [openValuationChargeModle.id].includes(modalType) && EditClick(false)}
    </>
  )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, getGSBranchValuationDetailsTableData, getgetGSEditValuationDetails, getBookingConsType, getBranchConfigOrEwbillinfo }
export default connect(mapStateToProps, mapDispatchToProps)(ValuationChargeTable)